<div class="agreement-overlay">
  <div class="agreement-modal">
    <div class="agreement-modal__content">
      <h3 class="agreement-modal__title">КУЛЬТУРА ОБЩЕНИЯ В&nbsp;BEFREE&nbsp;SOCIAL</h3>
      <div class="agreement-modal__text">
        <p>
          Привет! Мы очень ценим свободу, открытость и&nbsp;честный диалог.
          При&nbsp;этом&nbsp;для&nbsp;нас важно сохранить в&nbsp;команде доброжелательную
          и&nbsp;доверительную атмосферу, где&nbsp;каждому будет комфортно общаться и&nbsp;делиться
          своим мнением.
        </p>
        <p class="agreement-modal__text-before-list">
          Поэтому просим тебя придерживаться нескольких принципов коммуникации в&nbsp;Befree Social:
        </p>
        <ul>
          <li>
            Заботиться о&nbsp;конфиденциальности и&nbsp;безопасности данных — не&nbsp;передавать
            третьим лицам свой логин и&nbsp;пароль для&nbsp;входа в&nbsp;Befree Social, а&nbsp;также
            персональные данные сотрудников или&nbsp;любую другую информацию, опубликованную
            в&nbsp;сети.
          </li>
          <li>Размещать в&nbsp;Befree Social контент, допустимый законами РФ.</li>
          <li>
            Общаться вежливо и&nbsp;уважительно, во&nbsp;избежание лишних конфликтов
            и&nbsp;недопониманий.
          </li>
          <li>
            Учитывать специфику корпоративной социальной сети и&nbsp;не&nbsp;публиковать рекламу
            товаров и&nbsp;услуг: своих или&nbsp;сторонних компаний.
          </li>
        </ul>
        <p>Давай вместе формировать приятную и&nbsp;продуктивную рабочую среду!</p>
        <p class="agreement-modal__note base-file-subtitle">
          Модератор Befree Social оставляет за&nbsp;собой право удалять контент, который
          не&nbsp;соответствует культуре общения бренда.
        </p>
      </div>
    </div>

    <div class="agreement-modal__actions">
      <app-button
        btnType="button-base"
        text="принять"
        textSize="text-1"
        (click)="accept()"
      ></app-button>
    </div>
  </div>
</div>
